import axios, { AxiosInstance } from 'axios';
import { PhotoPriceSettingRulesRepository } from '~/model/repository/manager/parentSales/PhotoPriceSettingRulesRepository';

export default (Repository: AxiosInstance | null) =>
  (resource: string): PhotoPriceSettingRulesRepository => ({
    get() {
      const axiosInstance = Repository ?? axios.create({ withCredentials: true });
      return axiosInstance.get(`${resource}`);
    },
  });
